import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Button, FileInput, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import useContract, { useContractForm } from '@hooks/useContract'

const CreateContractModal = (props) => {
  const { callbacks, modalKey = 'CreateContractModal', showModal } = props
  const { closeModal, createContract } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, `${modalKey}`, {})
  const { contract } = modalPayload

  const {
    entityState,
    entityState: {
      attachment_data,
      expiry_date,
      start_date,
      title,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = useContractForm(contract, { validateOn: 'change' })

  const {
    callbacks: { createContract: createFn },
    creating,
  } = useContract(contract)

  const formSaveEnabled = saveEnabled && !!attachment_data

  const createContractPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    requestOptions: defaultRequestOptions.contract,
    toastText: 'Contract Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Contract" />

      <SidebarModal.Content>
        <Form>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.start_date} label="* Start Date" marginTop="large">
            <input name="start_date" type="date" value={start_date} {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.expiry_date} label="* Expiry Date" marginTop="large">
            <input name="expiry_date" min={start_date} type="date" value={expiry_date} {...handlers} />
          </Form.Field>

          <Form.Field label="* Upload Contract" marginTop="large">
            <FileInput
              input={{
                onChange: (fileData, fileObject) => {
                  setEntityState({ attachment_data: fileData, file_name: fileObject?.name })
                },
              }}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!formSaveEnabled}
          loading={creating}
          onClick={() => createContract(createContractPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Contract' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateContractModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateContractModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
